<template>
  <v-navigation-drawer
    id="core-navigation-drawer"
    v-model="drawer"
    :dark="barColor !== 'rgba(228, 226, 226, 1), rgba(255, 255, 255, 0.7)'"
    :expand-on-hover="expandOnHover"
    :right="$vuetify.rtl"
    :src="barImage"
    mobile-breakpoint="960"
    app
    width="260"
    v-bind="$attrs"
  >
    <template v-slot:img="props">
      <v-img
        :gradient="`to bottom, ${barColor}`"
        v-bind="props"
      />
    </template>

    <v-divider class="mb-1" />

    <v-list
      dense
      nav
    >
      <v-list-item>
        <v-img
          src="@/assets/logo_full.png"
          height="50"
          contain
        />
      </v-list-item>
      <!-- <v-list-item>
        <v-list-item-avatar
          class="align-self-center"
          color="white"
          contain
        >
          <v-img
            src="/favicon.ico"
            max-height="30"
          />
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title
            class="display-1"
            v-text="profile.title"
          />
        </v-list-item-content>
      </v-list-item> -->
    </v-list>

    <v-divider class="mb-2" />

    <v-list
      expand
      nav
    >
      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div />

      <template v-for="(item, i) in computedItems">
        <v-divider
          v-if="item.divider"
          :key="`item-${i}`"
          class="mb-2"
        />
        <base-item-group
          v-if="item.children"
          :key="`group-${i}`"
          :item="item"
        >
          <!--  -->
        </base-item-group>

        <base-item
          v-else
          :key="`item-${i}`"
          :item="item"
        />
      </template>

      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div />
    </v-list>

    <!---->
    <template v-slot:append>
      <!-- <base-item
        :item="{
          title: $t('upgrade'),
          icon: 'mdi-package-up',
          to: '/upgrade',
        }"
      /> -->
      <small class="grey--text"> ver. {{ appver }}</small>
    </template>
  </v-navigation-drawer>
</template>

<script>
  // Utilities
  import { mapState } from 'vuex'
  import Config from '@/config.js'

  export default {
    name: 'DashboardCoreDrawer',

    props: {
      expandOnHover: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      appver: Config.appver,
      items: [
        // {
        //   icon: 'mdi-view-dashboard',
        //   title: 'dashboard',
        //   to: '/',
        // },

        // {
        //   icon: 'mdi-newspaper-plus',
        //   title: 'Punti Raccolti',
        //   to: '/view/Raccoltapunti',
        // },
        {
          icon: 'mdi-cart-plus',
          title: 'Ordine Occhiale',
          to: '/view/ordini',
          // href: 'https://www.swissflex.it/ordini',
        },
        {
          icon: 'mdi-basket-fill',
          title: 'Ordine Ricambi',
          to: '/view/ricambi',
          // href: 'https://www.swissflex.it/ordini',
        },
        // {
        //   icon: 'mdi-eye-refresh',
        //   title: 'Riparazioni e Cambi lente',
        //   to: '/view/riparazioni',
        //   // href: 'https://www.swissflex.it/ordini',
        // },
        // {
        //   group: '/postvendita',
        //   icon: 'mdi-eye-refresh',
        //   title: 'Post-Vendita',
        //   children: [
        //     {
        //       icon: 'mdi-eye-refresh',
        //       title: 'Riparazioni',
        //       to: 'riparazioni',
        //     },
        //     {
        //       icon: 'mdi-format-list-bulleted',
        //       title: 'Cambi lente',
        //       to: 'cambilente',
        //     },

        //   ],
        // },
        // {
        //   group: '/test',
        //   icon: 'mdi-skull-scan',
        //   title: 'Test Idee',
        //   children: [
        //     {
        //       icon: 'mdi-view-list',
        //       title: 'IframeOrdini ',
        //       to: 'iframeOrdini',
        //     },
        //     {
        //       icon: 'mdi-glasses',
        //       title: 'FormeBslab',
        //       to: 'bslab',
        //       // href: 'https://www.swissflex.it/ordini',
        //     },

        //   ],
        // },
        {
          group: '/view/utility',
          icon: 'mdi-store-search',
          title: 'Ricerche',
          children: [
            {
              icon: '',
              title: 'Stato Ordini',
              to: 'order_status',
            },
            {
              icon: '',
              title: 'Archivio Ordini WEB',
              to: 'order_archive',
            },
            {
              icon: '',
              title: 'Archivio Ordini Ricambi',
              to: 'spareparts_archive',
            },
            // {
            //   icon: '',
            //   title: 'Lista Fatture',
            //   to: 'lista_fatture',
            // },
            // {
            //   icon: '',
            //   title: 'Copia DDT',
            //   to: 'copia_ddt',
            // },

          ],
        },
        {
          group: '/view/download',
          icon: 'mdi-cloud-download-outline',
          title: 'Download',
          children: [
            {
              icon: 'mdi-book-open-page-variant',
              title: 'Brochure',
              to: 'brochure',
            },
            {
              icon: 'mdi-bank',
              title: 'Listini',
              to: 'listini',
            },
            {
              icon: 'mdi-tools',
              title: 'Manuali Tecnici',
              to: 'manuali',
            },
            {
              icon: 'mdi-book-open-page-variant',
              title: 'Cartelli Vetrina',
              to: 'cartelli',
            },
            {
              icon: 'mdi-movie-open',
              title: 'Video Promozionali',
              to: 'video',
            },
            {
              icon: 'mdi-movie-open',
              title: 'Social Media Kit',
              to: 'social',
            },

          ],
        },
        {
          icon: 'mdi-lock',
          title: 'logout',
          to: '/logout',
        },

      ],
    }),

    computed: {
      ...mapState(['barColor', 'barImage']),
      drawer: {
        get () {
          return this.$store.state.drawer
        },
        set (val) {
          this.$store.commit('SET_DRAWER', val)
        },
      },
      computedItems () {
        return this.items.map(this.mapItem)
      },
      profile () {
        return {
          avatar: true,
          title: this.$t('avatar'),
        }
      },
    },

    methods: {
      mapItem (item) {
        return {
          ...item,
          children: item.children ? item.children.map(this.mapItem) : undefined,
          title: this.$t(item.title),
        }
      },
    },
  }
</script>

<style lang="sass">
  @import '~vuetify/src/styles/tools/_rtl.sass'

  #core-navigation-drawer
    .v-list-group__header.v-list-item--active:before
      opacity: .24

    .v-list-item
      &__icon--text,
      &__icon:first-child
        justify-content: center
        text-align: center
        width: 20px

        +ltr()
          margin-right: 24px
          margin-left: 12px !important

        +rtl()
          margin-left: 24px
          margin-right: 12px !important

    .v-list--dense
      .v-list-item
        &__icon--text,
        &__icon:first-child
          margin-top: 10px

    .v-list-group--sub-group
      .v-list-item
        +ltr()
          padding-left: 8px

        +rtl()
          padding-right: 8px

      .v-list-group__header
        +ltr()
          padding-right: 0

        +rtl()
          padding-right: 0

        .v-list-item__icon--text
          margin-top: 19px
          order: 0

        .v-list-group__header__prepend-icon
          order: 2

          +ltr()
            margin-right: 8px

          +rtl()
            margin-left: 8px
</style>
